// extracted by mini-css-extract-plugin
export default {"wrapper":"V2-z","play":"W2-z"};